import React from "react";
import moment from "moment";
import "../../assets/scss/base/pages/account/Voucher.scss";

// Components
import ShowMoreLessText from "../micro/ShowMoreLessText/ShowMoreLessText";
import ProductPlaceHolder from "../../assets/images/placeholder/ProductPlaceHolder.svg";

const imageCDN = process.env.REACT_APP_PINEAPPLE_IMAGE_CDN;

const VoucherModalCard = ({
  voucher,
  onApply,
  isApplying = false
}) => {

  // Normalize voucher data
  const normalizedVoucher =
    voucher?.Voucher || voucher?.voucher || voucher;

  const handleApply = () => {
    if (!isApplying) {
      onApply?.(voucher);
    }
  };

  const getDiscountDisplay = () => {
    if (normalizedVoucher?.type === "Flat") {
      return `RM ${normalizedVoucher?.typeValue} OFF`;
    }
    if (normalizedVoucher?.type === "Percentage") {
      return `${normalizedVoucher?.typeValue}% OFF`;
    }
    return "Discount";
  };

  const getSellerDisplay = () => {
    if (normalizedVoucher?.forAllVendors) return "Pineapple.my";

    if (Array.isArray(normalizedVoucher?.vendors)) {
      return normalizedVoucher.vendors
        .map(v => v.companyName)
        .join(", ");
    }

    return "N/A";
  };

  const getTimeLeftLabel = () => {
    const validTill =
      normalizedVoucher?.validTo ||
      normalizedVoucher?.validTill;

    if (!validTill) return null;

    const now = moment();
    const expiry = moment.unix(validTill);

    const minutesLeft = expiry.diff(now, "minutes");

    if (minutesLeft <= 0) return null;

    if (minutesLeft < 60) {
      return {
        label: `${minutesLeft} min left`,
        isUrgent: true,
      };
    }

    if (minutesLeft < 24 * 60) {
      const hoursLeft = Math.ceil(minutesLeft / 60);
      return {
        label: `${hoursLeft} ${hoursLeft === 1 ? "hour" : "hours"} left`,
        isUrgent: true,
      };
    }


    const daysLeft = Math.ceil(minutesLeft / (24 * 60));

    return {
      label: `${daysLeft} days left`,
      isUrgent: daysLeft < 10,
    };
  };

  const brands = Array.isArray(normalizedVoucher.brands)
    ? normalizedVoucher.brands
    : [];

  const getBrandImage = (brand) => {
    const path = brand?.logo || brand?.file;
    return path ? `${imageCDN}/${path}` : ProductPlaceHolder;
  };

  const getRemainingBrandNames = (visibleCount) =>
    brands
      .slice(visibleCount)
      .map((brand) => brand?.name)
      .filter(Boolean)
      .join(", ");

  const handleBrandImageError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = ProductPlaceHolder;
  };

  return (
    <div className="voucher-card-ui">
      {/* LEFT RIBBON */}
      <div className="voucher-ribbon">
        <span>{getDiscountDisplay()}</span>

        <div className="voucher-ribbon-dots">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="voucher-content">
        {brands.length > 0 && (
          <div className="voucher-brands">
            <div className="voucher-brands-row">
              {brands.map((brand) => (
                <div
                  key={brand.id}
                  className="voucher-brand-logo"
                  title={brand.name}
                >
                  <img
                    src={getBrandImage(brand)}
                    alt={brand.name || "Brand"}
                    onError={handleBrandImageError}
                  />
                </div>
              ))}
              {brands.length > 2 && (
                <div
                  className="voucher-brand-more voucher-brand-more--sm"
                  title={getRemainingBrandNames(2)}
                >
                  +{brands.length - 2}
                </div>
              )}
              {brands.length > 3 && (
                <div
                  className="voucher-brand-more voucher-brand-more--md"
                  title={getRemainingBrandNames(3)}
                >
                  +{brands.length - 3}
                </div>
              )}
              {brands.length > 4 && (
                <div
                  className="voucher-brand-more voucher-brand-more--lg"
                  title={getRemainingBrandNames(4)}
                >
                  +{brands.length - 4}
                </div>
              )}
            </div>
          </div>
        )}

        <div className="voucher-header-ui">
          <h3 className="voucher-title-ui">
            {normalizedVoucher?.code?.length > 30
              ? normalizedVoucher.code.slice(0, 30) + "..."
              : normalizedVoucher?.code}
          </h3>

          <button
            className="claim-now-btn"
            onClick={handleApply}
            disabled={isApplying}
          >
            {isApplying ? "Applying..." : "APPLY"}
          </button>
        </div>

        <p className="voucher-info-ui">
          Save{" "}
          {normalizedVoucher?.type === "Flat"
            ? `RM ${normalizedVoucher?.typeValue} OFF`
            : `${normalizedVoucher?.typeValue}% OFF`}{" "}
          on this order!
        </p>

        <div className="voucher-divider" />

        <p className="voucher-seller-ui">
          Seller : <span>{getSellerDisplay()}</span>
        </p>

        <div className="voucher__item__details__block">
          <ShowMoreLessText
            text={normalizedVoucher?.description}
            lines={2}
          />
        </div>

        {(() => {
          const timeLeft = getTimeLeftLabel();
          if (!timeLeft) return null;

          return (
            <p
              className={`voucher-days-left ${timeLeft.isUrgent ? "danger" : "success"
                }`}
            >
              {timeLeft.label}
            </p>
          );
        })()}


      </div>
    </div>
  );
};

export default VoucherModalCard;
